import React, { Component } from 'react';

import cx from 'classnames';
import { CONTENT } from '../../styles/formModal';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import BaseModal from '../BaseModal';


















































/**
 * A FormModal component that contains cancel, save and close buttons
 *
 * @param {FormModalProps} props
 *
 * @return {React.Element}
 */
class FormModalComponent extends Component


{
  static defaultProps = {
    saveText: 'Save Changes',
    stayOpenOnSave: false
  };

  constructor(props) {
    super(props);

    this.state = {
      saving: false
    };
  }

  /**
   * Handle save action when the save button is clicked.
   *
   * @return {void}
   */
  handleSave = async () => {
    const {
      onClose,
      onSave,
      stayOpenOnSave




    } = this.props;

    if (!onSave) {
      return;
    }

    this.setState({ saving: true });

    await onSave();

    this.setState({ saving: false }, () => {
      if (stayOpenOnSave) {
        return;
      }

      onClose();
    });
  };

  render() {
    const {
      componentRef,
      visible,
      onClose,
      children,
      saveText,
      closeText,
      closeBtnType,
      title,
      subtitle,
      description,
      onSave,
      saveDisabled,
      showBackBtn,
      onBackClick,
      hideFooter,
      footerChildren,
      headerSuffix,
      closeOnEsc,
      closeMaskOnClick,
      showHeaderCloseButton,
      showCancelBtn,
      handlePrint,
      printText,
      showPrintBtn,
      titleProps,
      saveBtnType,
      className,
      isFullWidth,
      mediumWidth,
      isAutoWidth = true,
      minWidth,
      showExtraButtons,
      footerExtraButtons,
      saveButtonId,
      printBtnType = 'PRIMARY',
      loadingSave = false,
      ...modalCommonProps
    } = this.props;
    const { saving } = this.state;
    const showSaving = saving || loadingSave;

    return (
      <BaseModal
        {...modalCommonProps}
        visible={visible}
        onClose={onClose}
        closeOnEsc={closeOnEsc}
        closeMaskOnClick={closeMaskOnClick}
        showHeaderCloseButton={showHeaderCloseButton}
        className={className}
        isFullWidth={isFullWidth}
        mediumWidth={mediumWidth}
        minWidth={minWidth}
        isAutoWidth={isAutoWidth}>

        {title &&
        <ModalHeader
          title={title}
          subtitle={subtitle}
          description={description}
          showBackBtn={showBackBtn}
          onBackClick={onBackClick}
          titleProps={titleProps}
          suffix={headerSuffix} />}


        <div ref={componentRef} className={cx(CONTENT, 'modal__content')}>
          {children}
        </div>
        {!hideFooter &&
        <ModalFooter
          className="modal__footer"
          saveButtonId={saveButtonId}
          footerChildren={footerChildren}
          saveText={saveText}
          closeText={closeText}
          closeBtnType={closeBtnType}
          onClose={onClose}
          onSave={onSave ? this.handleSave : void 0}
          saving={showSaving}
          handlePrint={handlePrint}
          printText={printText}
          printBtnType={printBtnType}
          showPrintBtn={showPrintBtn}
          saveDisabled={saveDisabled}
          showCancelBtn={showCancelBtn}
          title={title}
          saveBtnType={saveBtnType}
          showExtraButtons={showExtraButtons}
          footerExtraButtons={footerExtraButtons} />}


      </BaseModal>);

  }
}

export default FormModalComponent;